/**
 * Tek kaynak: backend `JobStatus` enum'unun (Beetegre.Domain/Entities/MarketplaceStore.cs) UI aynasi.
 * Endpoint'ler enum'u int olarak dondurur; sayi, etiket anahtari, rozet rengi ve canli/terminal
 * ayrimi burada yasar ki bir yuzey digerinden farkli renk ya da etiket gostermesin.
 */
export const JobStatus = {
  Pending: 0,
  Running: 1,
  Completed: 2,
  Failed: 3,
  Cancelled: 4,
} as const;

export type JobStatusValue = (typeof JobStatus)[keyof typeof JobStatus];

export type JobStatusBadgeVariant = 'success' | 'destructive' | 'warning' | 'secondary';

/** `marketplace.jobs.<key>` i18n anahtar son ekleri. */
export const JOB_STATUS_LABEL_KEY: Record<JobStatusValue, string> = {
  [JobStatus.Pending]: 'statusPending',
  [JobStatus.Running]: 'statusRunning',
  [JobStatus.Completed]: 'statusCompleted',
  [JobStatus.Failed]: 'statusFailed',
  [JobStatus.Cancelled]: 'statusCancelled',
};

const JOB_STATUS_VARIANT: Record<JobStatusValue, JobStatusBadgeVariant> = {
  [JobStatus.Pending]: 'secondary',
  [JobStatus.Running]: 'warning',
  [JobStatus.Completed]: 'success',
  [JobStatus.Failed]: 'destructive',
  [JobStatus.Cancelled]: 'secondary',
};

/** Bilinmeyen sayi (backend yeni bir deger eklerse) notr gorunur, cokmez. */
export const jobStatusVariant = (status: number): JobStatusBadgeVariant =>
  JOB_STATUS_VARIANT[status as JobStatusValue] ?? 'secondary';

/** Rozet metni; backend'e yeni bir statu eklenirse bos/`undefined` anahtar yerine ham sayi gorunur. */
export const jobStatusLabel = (status: number, t: (key: string) => string): string => {
  const suffix = JOB_STATUS_LABEL_KEY[status as JobStatusValue];
  return suffix ? t(`marketplace.jobs.${suffix}`) : String(status);
};

// "Completed with errors" icin her job yuzeyinde tek ton; amber zaten Running demek.
export const COMPLETED_WITH_ERRORS_VARIANT = 'destructive' as const;

const LIVE_STATUSES: ReadonlySet<number> = new Set<number>([JobStatus.Pending, JobStatus.Running]);

const TERMINAL_STATUSES: ReadonlySet<number> = new Set<number>([
  JobStatus.Completed,
  JobStatus.Failed,
  JobStatus.Cancelled,
]);

/** Pending/Running: polling surmeli, iptal edilebilir. */
export const isLiveJobStatus = (status: number): boolean => LIVE_STATUSES.has(status);

export const isTerminalJobStatus = (status: number): boolean => TERMINAL_STATUSES.has(status);
